import { AsyncResult, ServerError } from 'Core/models/Async';
import ProposalAPI from 'Quoting/api/ProposalAPI';
import { ProposalQuoteDetails } from 'Quoting/models/DTOs/Proposal';
import { isRight, left } from 'fp-ts/lib/Either';
import { call } from 'redux-saga/effects';

export function* retreivePoliciesWithRates(quoteLinks: string[], limitFields: boolean = false) {
  const error = 'Failed to retrieve policies with rates!';
  try {
    const response: AsyncResult<ProposalQuoteDetails[]> = yield call(ProposalAPI.getQuotesLinkedToProposal, quoteLinks, limitFields);
    if (isRight(response) && response.right.length > 0) {
      return response;
    }
    return left(new ServerError(error));
  } catch (err) {
    throw new Error(error);
  }
}
